import { useEffect } from "react";
import "./ConfirmationStepStudyOrder.scss";

export default function ConfirmationStepStudyOrder({
  patient,
  studyOrderData,
  onValidationChange
}: any) {

  const items = studyOrderData?.items ?? [];

  useEffect(() => {
    const valid =
      !!patient &&
      !!studyOrderData &&
      items.length > 0;

    onValidationChange(valid);
  }, [patient, studyOrderData, items]);

  return (
    <div className="cs-container">

      <h3 className="cs-title">Confirmar orden</h3>

      {/* Paciente */}
      <div className="cs-block">
        <div className="cs-label">Paciente</div>
        <div className="cs-card">
          <div>{patient?.firstname ?? "-"} {patient?.lastname ?? ""}</div>
          <div>DNI: {patient?.document ?? "-"}</div>
          <div>Cel: {patient?.mobilephone ?? "-"}</div>

          {patient?.insurances?.length ? (
            <div>
              {patient.insurances[0]?.healthentityplan?.healthentity?.commercialname ?? "-"}
              {" – "}
              {patient.insurances[0]?.healthentityplan?.name ?? "-"}
            </div>
          ) : (
            <div>Sin obra social</div>
          )}
        </div>
      </div>

      {/* Fecha */}
      <div className="cs-block">
        <div className="cs-label">Fecha</div>
        <div className="cs-value">
          {studyOrderData?.emissionDate
            ? new Date(studyOrderData.emissionDate).toLocaleDateString()
            : ""}
        </div>
      </div>

      {/* Prescripción */}
      <div className="cs-block">
        <div className="cs-label">Prescripción</div>
        <div className="cs-card">
          <ul className="cs-list">
            {items.map((it: any) => (
              <li key={it.id}>
                {it.code ? `${it.code} ${it.description}` : it.description}
              </li>
            ))}
          </ul>
        </div>
      </div>

      {/* Diagnóstico */}
      <div className="cs-block">
        <div className="cs-label">Diagnóstico general</div>
        <div className="cs-value">{studyOrderData?.diagnosis || "—"}</div>
      </div>

      {/* Ocultar datos */}
      <div className="cs-block">
        <div className="cs-value">
          {studyOrderData?.hidePatientData
            ? "Ocultar datos del paciente"
            : "Datos visibles"}
        </div>
      </div>

    </div>
  );
}
